import { call, put, takeLatest } from 'redux-saga/effects';
import ApiUtil from 'src/utils/ApiUtil';
import {
  getProgramFeesQueryFailedAction,
  getProgramFeesQuerySuccessAction,
  PROGRAM_FEES_QUERY_START,
  ADDITIONAL_PROGRAM_FEES_QUERY_START,
  UPDATE_PROGRAM_FEES_QUERY_START,
  ProgramFeesQueryStartAction,
  PROGRAM_FEES_WITH_TAXES_QUERY_START,
  getProgramFeesWithTaxesQuerySuccessAction,
  getProgramFeesWithTaxesQueryFailedAction,
  WIDGET_PROGRAM_FEES_QUERY_START,
} from 'src/actions/ProgramFeesQueryAction';
import ProductDataValidator from 'src/utils/ProductDataValidator';
import {
  dimensionUnitAbbrMap,
  getDimensionUnitAbbrConfig,
  getWeightUnitAbbrConfig,
  isWidget,
  weightUnitAbbrMap,
} from 'src/config/Config';

export function* getProgramFees(action: ProgramFeesQueryStartAction) {
  try {
    const countryCode = action.countryCode;
    let parameters;
    if (action.programParamMap != undefined) {
      parameters = {
        countryCode,
        itemInfo: action.queryProduct,
        programIdList: action.programIdList,
        programParamMap: action.programParamMap,
        isTaxEnabled: action.isTaxEnabled,
      };
    } else {
      parameters = {
        countryCode,
        itemInfo: action.queryProduct,
        programIdList: action.programIdList,
        isTaxEnabled: action.isTaxEnabled,
      };
    }

    if (isWidget()) {
      const isDimensionAndWeightValid =
        ProductDataValidator.isQueryProductDimensionValid(action.queryProduct);
      if (!isDimensionAndWeightValid) {
        parameters = {
          ...parameters,
          programIdList: ['MFN'],
          itemInfo: {
            ...action.queryProduct,
            dimensionUnit:
              dimensionUnitAbbrMap[getDimensionUnitAbbrConfig(countryCode)],
            weightUnit: weightUnitAbbrMap[getWeightUnitAbbrConfig(countryCode)],
            packageLength: '0',
            packageWidth: '0',
            packageHeight: '0',
            packageWeight: '0',
          },
        };
      }
    }
    // @ts-expect-error
    const response = yield call(
      ApiUtil.postApiWithTimeout,
      'getfees',
      parameters,
    );
    if (response.succeed) {
      if (action.type === PROGRAM_FEES_WITH_TAXES_QUERY_START) {
        yield put(
          getProgramFeesWithTaxesQuerySuccessAction(
            action.programIdList,
            response.data,
          ),
        );
      } else {
        yield put(
          getProgramFeesQuerySuccessAction(action.programIdList, response.data),
        );
      }
    } else {
      if (action.type === PROGRAM_FEES_WITH_TAXES_QUERY_START) {
        yield put(
          getProgramFeesWithTaxesQueryFailedAction(action.programIdList),
        );
      } else {
        yield put(getProgramFeesQueryFailedAction(action.programIdList));
      }
    }
  } catch (error) {
    console.error('Call API getfees error' + error);
    if (action.type === PROGRAM_FEES_WITH_TAXES_QUERY_START) {
      yield put(getProgramFeesWithTaxesQueryFailedAction(action.programIdList));
    } else {
      yield put(getProgramFeesQueryFailedAction(action.programIdList));
    }
  }
}

export default function* programFees() {
  yield takeLatest(
    [
      WIDGET_PROGRAM_FEES_QUERY_START,
      PROGRAM_FEES_QUERY_START,
      ADDITIONAL_PROGRAM_FEES_QUERY_START,
      UPDATE_PROGRAM_FEES_QUERY_START,
      PROGRAM_FEES_WITH_TAXES_QUERY_START,
    ],
    getProgramFees,
  );
}
